const CoverBgColors = {
  PINK: "#eb84c5",
  BLUE: "#97b7ee",
  ORANGE: "#fda600"
}

export const ThemeColors = {
  Navy: "var(--color-primary)",
  Slate: "var(--color-slate)",
  Sage: "var(--color-accent)",
  White: "var(--color-bg-white)",
  OffWhite: "var(--color-bg-offwhite)",
  LightSage: "#CAD2C5", // Preserved
  TextDark: "var(--color-text-dark)",
  TextLight: "var(--color-text-light)"
}

export default CoverBgColors